import React from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox as MUICheckBox,
  FormControlLabel as MUIFormControlLabel
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { fonts } from '@constants/fonts';

const useStyles = makeStyles()({
  label: {
    fontSize: fonts.md
  }
});

export const Checkbox = ({
  color = 'primary',
  label = '',
  checked = false,
  name = '',
  // v9 removed Checkbox/SwitchBase's own `inputProps` prop entirely (now `slotProps.input`) —
  // translated here so existing callers (e.g. filter-checkbox.js's aria-label) don't need to change.
  inputProps,
  slotProps,
  ...data
}) => {
  const { classes } = useStyles();

  return label ? (
    <MUIFormControlLabel
      label={label}
      classes={classes}
      control={<MUICheckBox color={color} checked={checked} name={name} {...data} />}
    />
  ) : (
    <MUICheckBox
      color={color}
      checked={checked}
      name={name}
      {...data}
      slotProps={{
        ...slotProps,
        input: { 'aria-label': name, ...inputProps, ...slotProps?.input }
      }}
    />
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  color: PropTypes.string,
  inputProps: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string,
  slotProps: PropTypes.object
};

export default Checkbox;
